import React from "react";

import { Eyebrow, Title } from "../components/CommonComponents";
import MetaInfo from "../components/MetaInfo";
import Header from "../components/Header";
import Footer from "../components/Footer";

import iauLogo from "../assets/img/rec/iau.webp";


export default function AccreditationIau() {
    return (
        <>
            <MetaInfo param="" id="about" />
            <Header school="common" />

            <main className="bg-white text-[#132337]">

                {/* ====================================================== */}
                {/* HERO */}
                {/* ====================================================== */}

                <section className="relative overflow-hidden bg-[#071A2F] pt-[100px] text-white">

                    <div className="pointer-events-none absolute inset-0">
                        <div className="absolute right-0 top-0 h-full w-[42%] bg-[#0C2744]" />
                        <div className="absolute right-0 top-0 h-full w-[42%] opacity-[0.035] [background-image:linear-gradient(rgba(255,255,255,.7)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,.7)_1px,transparent_1px)] [background-size:58px_58px]" />
                        <div className="absolute -right-[140px] top-[60px] h-[590px] w-[590px] rounded-full border border-white/[0.05]" />
                        <div className="absolute right-[45px] top-[180px] h-[330px] w-[330px] rounded-full border border-white/[0.06]" />
                        <div className="absolute bottom-0 left-0 h-[5px] w-[34%] bg-[#8B1E3F]" />
                    </div>

                    <div className="relative mx-auto grid min-h-[620px] w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)] lg:grid-cols-[1.08fr_.92fr]">

                        {/* LEFT */}
                        <div className="flex flex-col justify-center py-16 pr-8 lg:py-20 lg:pr-20">

                            <div className="flex items-center gap-4 text-sm font-bold uppercase tracking-[0.18em] text-white/55">
                                <span className="h-px w-12 bg-[#8B1E3F]" />
                                IAU Membership
                            </div>

                            <h1 className="mt-7 max-w-[840px] font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(52px,6vw,88px)] font-normal leading-[0.95] tracking-[-0.045em]">
                                Connected to the
                                <span className="block text-[#D5AD57]">
                                    global academic community.
                                </span>
                            </h1>

                            <p className="mt-8 max-w-[700px] text-[17px] leading-8 text-white/60">
                                ISBM University's membership in the International Association of Universities reflects its connection with a wider international higher education community.
                            </p>

                            <div className="mt-10 flex flex-wrap gap-x-8 gap-y-4 border-t border-white/10 pt-7">

                                {[
                                    "International Network",
                                    "Academic Exchange",
                                    "Global Perspective",
                                    "Higher Education",
                                ].map((item) => (
                                    <div key={item} className="flex items-center gap-3">

                                        <span className="h-1.5 w-1.5 rotate-45 bg-[#8B1E3F]" />

                                        <span className="text-[10px] font-bold uppercase tracking-[0.13em] text-white/55">
                                            {item}
                                        </span>

                                    </div>
                                ))}

                            </div>

                        </div>


                        {/* RIGHT */}
                        <div className="relative hidden lg:flex lg:items-center lg:justify-center">

                            <div className="relative w-[390px]">

                                <div className="bg-white p-10 shadow-[0_30px_80px_rgba(0,0,0,.25)]">

                                    <div className="border border-[#071A2F]/10 p-7">

                                        <div className="flex items-center justify-between border-b border-[#071A2F]/10 pb-5">

                                            <span className="text-[9px] font-bold uppercase tracking-[0.17em] text-[#8B1E3F]">
                                                International Membership
                                            </span>

                                            <span className="text-[9px] font-bold uppercase tracking-[0.14em] text-[#071A2F]/35">
                                                IAU
                                            </span>

                                        </div>

                                        <div className="flex min-h-[220px] items-center justify-center">

                                            <img src={iauLogo} alt="International Association of Universities" className="max-h-[130px] max-w-[220px] object-contain" />

                                        </div>

                                        <div className="border-t border-[#071A2F]/10 pt-5">

                                            <span className="text-[9px] font-bold uppercase tracking-[0.14em] text-[#8B1E3F]">
                                                Member Institution
                                            </span>

                                            <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[26px] text-[#071A2F]">
                                                ISBM University
                                            </p>

                                        </div>

                                    </div>

                                </div>

                                <div className="ml-auto mt-[-18px] w-[220px] bg-[#8B1E3F] p-5 text-white">

                                    <span className="text-[8px] font-bold uppercase tracking-[0.15em] text-white/55">
                                        Global Outlook
                                    </span>

                                    <p className="mt-3 font-['Libre_Caslon_Display',Georgia,serif] text-[21px] leading-[1.2]">
                                        Academic connection beyond borders.
                                    </p>

                                </div>

                            </div>

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* ABOUT IAU */}
                {/* ====================================================== */}

                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto grid w-[min(1380px,calc(100%-48px))] gap-14 max-sm:w-[calc(100%-28px)] lg:grid-cols-[.68fr_1.32fr] lg:gap-20">

                        <div>

                            <Eyebrow>
                                IAU Membership
                            </Eyebrow>

                            <Title before="Connected Through" highlight="Higher Education" after="" position="middle" theme="burgundy" />

                        </div>


                        <div className="lg:pt-7">

                            <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[clamp(27px,3vw,41px)] font-normal leading-[1.35] text-[#071A2F]">
                                Membership supports institutional engagement with broader developments, conversations and perspectives in higher education.
                            </p>

                            <p className="mt-7 max-w-[850px] text-[15px] leading-8 text-[#65727E]">
                                It reflects the University's interest in connecting with academic communities beyond national boundaries and strengthening an international perspective within its institutional development.
                            </p>

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* MEMBERSHIP PERSPECTIVE */}
                {/* ====================================================== */}

                <section className="bg-[#F7F2E8] py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-12 lg:grid-cols-[.72fr_1.28fr] lg:gap-20">

                            <div>

                                <Eyebrow>
                                    International Perspective
                                </Eyebrow>

                                <Title before="A Broader" highlight="Academic Outlook" after="" position="middle" theme="burgundy" />

                                <p className="mt-7 max-w-[450px] text-[15px] leading-8 text-[#65727E]">
                                    Global academic engagement allows institutions to observe developments, exchange perspectives and strengthen their understanding of higher education beyond national boundaries.
                                </p>

                                <div className="mt-10 border-l-[3px] border-[#8B1E3F] pl-6">

                                    <p className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] leading-[1.4] text-[#071A2F]">
                                        International engagement supports a university's ability to think beyond its own institutional environment.
                                    </p>

                                </div>

                            </div>


                            <div className="grid gap-px bg-[#071A2F]/10 sm:grid-cols-2">

                                {[
                                    {
                                        number: "01",
                                        title: "International Connectivity",
                                        text: "Connection with the wider international higher education community and institutional networks.",
                                        background: "bg-white",
                                    },
                                    {
                                        number: "02",
                                        title: "Academic Dialogue",
                                        text: "Engagement with conversations, perspectives and developments influencing universities globally.",
                                        background: "bg-[#EEF4F8]",
                                    },
                                    {
                                        number: "03",
                                        title: "Institutional Learning",
                                        text: "Opportunities to observe and learn from wider academic practices and institutional experiences.",
                                        background: "bg-[#F4E8EC]",
                                    },
                                    {
                                        number: "04",
                                        title: "Global Orientation",
                                        text: "Supporting an academic outlook that considers international developments in higher education.",
                                        background: "bg-[#071A2F] text-white",
                                    },
                                ].map((item) => (
                                    <article key={item.number} className={`min-h-[280px] p-8 ${item.background}`}>

                                        <span className={`font-['Libre_Caslon_Display',Georgia,serif] text-[31px] ${item.number === "04" ? "text-[#E7C7D2]" : "text-[#8B1E3F]"}`}>
                                            {item.number}
                                        </span>

                                        <h3 className="mt-8 font-['Libre_Caslon_Display',Georgia,serif] text-[26px] font-normal leading-[1.15]">
                                            {item.title}
                                        </h3>

                                        <p className={`mt-5 text-[14px] leading-7 ${item.number === "04" ? "text-white/55" : "text-[#65727E]"}`}>
                                            {item.text}
                                        </p>

                                    </article>
                                ))}

                            </div>

                        </div>

                    </div>

                </section>


                {/* ====================================================== */}
                {/* WHAT MEMBERSHIP REPRESENTS */}
                {/* ====================================================== */}

                <section className="bg-white py-20 sm:py-24 lg:py-28">

                    <div className="mx-auto w-[min(1380px,calc(100%-48px))] max-sm:w-[calc(100%-28px)]">

                        <div className="grid gap-10 border-b border-[#071A2F]/15 pb-10 lg:grid-cols-[1fr_420px] lg:items-end">

                            <div>

                                <Eyebrow>
                                    What Membership Represents
                                </Eyebrow>

                                <Title before="Engagement Beyond" highlight="Institutional Boundaries" after="" position="middle" theme="burgundy" />

                            </div>


                            <p className="text-[15px] leading-8 text-[#65727E]">
                                Membership provides an opportunity to remain connected with a broader higher education environment while strengthening institutional awareness of global academic developments.
                            </p>

                        </div>


                        <div className="mt-14 border-t border-[#071A2F]/15">

                            {[
                                ["01", "Global Academic Community", "Participation in a broader network of universities and higher education institutions."],
                                ["02", "International Perspective", "Greater awareness of ideas, practices and developments across international higher education."],
                                ["03", "Academic Engagement", "Opportunities for institutional dialogue and learning beyond the University's immediate environment."],
                                ["04", "Institutional Development", "Supporting a broader perspective when considering academic and institutional growth."],
                            ].map(([number, title, text]) => (
                                <article key={number} className="grid gap-5 border-b border-[#071A2F]/15 py-7 sm:grid-cols-[65px_240px_1fr]">

                                    <span className="font-['Libre_Caslon_Display',Georgia,serif] text-[28px] text-[#8B1E3F]">
                                        {number}
                                    </span>

                                    <h3 className="font-['Libre_Caslon_Display',Georgia,serif] text-[24px] font-normal leading-[1.2] text-[#071A2F]">
                                        {title}
                                    </h3>

                                    <p className="text-[14px] leading-7 text-[#65727E]">
                                        {text}
                                    </p>

                                </article>
                            ))}

                        </div>

                    </div>

                </section>

            </main>

            <Footer />
        </>
    );
}